/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Create_Product_QuickInputs */

const vi_pos_create_product_quick = /** @type {(inputs: Pos_Create_Product_QuickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm sản phẩm mới`)
};

/**

* @param {Pos_Create_Product_QuickInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_create_product_quick = /** @type {((inputs?: Pos_Create_Product_QuickInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Create_Product_QuickInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_create_product_quick(inputs)
});